import { IdoRecord } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

export class CreateIdoRecordCallback extends Callback<IdoRecord[]> {
	public constructor(
		private readonly setIdoRecord: (payload: IdoRecord | null) => void,
		private readonly setNewIdoRecordId: (payload: null | number) => void,
		private readonly setNewIdoRecordInstanceId: (payload: null | number) => void,
		private readonly fetchTheCreatedIdoRecord: (idoId: number, idoInstanceId: number) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: IdoRecord[]): void => {
		const createdRecord = successResponse[0];
		const jsonModel = createdRecord?.jsonModel;

		if (
			successResponse.length > 0 &&
			Object.prototype.hasOwnProperty.call(createdRecord, 'jsonModel') &&
			jsonModel
		) {
			this.setNewIdoRecordId(Number(jsonModel.idoId));
			this.setNewIdoRecordInstanceId(Number(jsonModel.idoInstanceId));
			this.setIdoRecord(createdRecord);
			this.fetchTheCreatedIdoRecord(Number(jsonModel.idoId), Number(jsonModel.idoInstanceId));
		}
	};
}
